var _rect, _g, _rect2, _rect3, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustrationKyc = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 703,
    height: 780,
    viewBox: "0 0 703 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 703,
    height: 780,
    rx: 32,
    fill: "#F8EEE9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4556_19496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.5 446.855H231.779V446.445H231.5V446.855ZM231.5 565.212V565.623H231.779V565.212H231.5ZM111.5 446.855V447.266H231.5V446.855V446.445H111.5V446.855ZM231.5 446.855H231.221V565.212H231.5H231.779V446.855H231.5ZM231.5 565.212V564.801H111.5V565.212V565.623H231.5V565.212Z",
    fill: "#191B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.499 471.2V540.867",
    stroke: "#191B1B",
    strokeWidth: 0.796013
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.333 506.033H136.666",
    stroke: "#191B1B",
    strokeWidth: 0.796013
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.128 481.404L146.871 530.662",
    stroke: "#191B1B",
    strokeWidth: 0.796013
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.128 530.662L146.871 481.404",
    stroke: "#191B1B",
    strokeWidth: 0.796013
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 446.855V446.445H231.089V446.855H231.5ZM351.5 446.855H351.911V446.445H351.5V446.855ZM351.5 565.212V565.623H351.911V565.212H351.5ZM231.5 565.212H231.089V565.623H231.5V565.212ZM231.5 446.855V447.266H351.5V446.855V446.445H231.5V446.855ZM351.5 446.855H351.089V565.212H351.5H351.911V446.855H351.5ZM351.5 565.212V564.801H231.5V565.212V565.623H351.5V565.212ZM231.5 565.212H231.911V446.855H231.5H231.089V565.212H231.5Z",
    fill: "#191B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5 446.855V446.445H351.089V446.855H351.5ZM471.5 446.855H471.911V446.445H471.5V446.855ZM471.5 565.212V565.623H471.911V565.212H471.5ZM351.5 565.212H351.089V565.623H351.5V565.212ZM351.5 446.855V447.266H471.5V446.855V446.445H351.5V446.855ZM471.5 446.855H471.089V565.212H471.5H471.911V446.855H471.5ZM471.5 565.212V564.801H351.5V565.212V565.623H471.5V565.212ZM351.5 565.212H351.911V446.855H351.5H351.089V565.212H351.5Z",
    fill: "#191B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.378 475.92L441.621 536.147H381.378L441.621 475.92H381.378Z",
    stroke: "#191B1B",
    strokeWidth: 0.796868
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 446.855V446.445H471.221V446.855H471.5ZM471.5 565.212H471.221V565.623H471.5V565.212ZM471.5 446.855V447.266H591.5V446.855V446.445H471.5V446.855ZM591.5 565.212V564.801H471.5V565.212V565.623H591.5V565.212ZM471.5 565.212H471.779V446.855H471.5H471.221V565.212H471.5Z",
    fill: "#191B1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.5 472.746C522.308 472.746 514.856 480.198 514.856 489.39V502.335H513.007C508.921 502.335 505.609 505.647 505.609 509.732V531.924C505.609 536.01 508.921 539.321 513.007 539.321H549.993C554.078 539.321 557.39 536.01 557.39 531.924V509.732C557.39 505.647 554.078 502.335 549.993 502.335H548.144V489.39C548.144 480.198 540.692 472.746 531.5 472.746ZM542.596 502.335V489.39C542.596 483.262 537.628 478.294 531.5 478.294C525.372 478.294 520.404 483.262 520.404 489.39V502.335H542.596Z",
    stroke: "#B54509",
    strokeWidth: 0.932039
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111.089,
    y: 215.343,
    width: 480.822,
    height: 349.315,
    rx: 16.8493,
    stroke: "#191B1B",
    strokeWidth: 0.821918
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 135.034,
    transform: "translate(156 272)",
    fill: "#F8EEE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.944 273.36C477.412 272.139 479.554 272.139 481.021 273.36C497.24 286.862 517.768 295.342 540.231 296.42C542.045 296.507 543.569 297.817 543.803 299.586C544.373 303.907 544.667 308.317 544.667 312.795C544.667 355.708 517.638 392.292 479.716 406.369C478.922 406.664 478.046 406.664 477.253 406.369C439.329 392.293 412.299 355.708 412.299 312.794C412.299 308.316 412.593 303.907 413.163 299.586C413.397 297.817 414.921 296.507 416.734 296.42C439.197 295.342 459.726 286.862 475.944 273.36Z",
    fill: "#F8EEE9",
    stroke: "black",
    strokeWidth: 0.888383
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.659 273.36C392.127 272.139 394.269 272.139 395.736 273.36C411.955 286.862 432.483 295.342 454.946 296.42C456.76 296.507 458.284 297.817 458.518 299.586C459.088 303.907 459.382 308.317 459.382 312.795C459.382 355.708 432.353 392.292 394.431 406.369C393.637 406.664 392.761 406.664 391.968 406.369C354.044 392.293 327.014 355.708 327.014 312.794C327.014 308.316 327.308 303.907 327.878 299.586C328.112 297.817 329.635 296.507 331.449 296.42C353.912 295.342 374.44 286.862 390.659 273.36Z",
    fill: "#F8EEE9",
    stroke: "black",
    strokeWidth: 0.888383
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M305.375 273.36C306.843 272.139 308.984 272.139 310.452 273.36C326.671 286.862 347.199 295.342 369.662 296.42C371.476 296.507 373 297.817 373.233 299.586C373.804 303.907 374.098 308.317 374.098 312.795C374.097 355.708 347.068 392.292 309.146 406.369C308.353 406.664 307.477 406.664 306.684 406.369C268.76 392.293 241.73 355.708 241.729 312.794C241.729 308.316 242.024 303.907 242.594 299.586C242.827 297.817 244.351 296.507 246.165 296.42C268.628 295.342 289.156 286.862 305.375 273.36Z",
    fill: "#F8EEE9",
    stroke: "black",
    strokeWidth: 0.888383
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.09 273.36C221.558 272.139 223.699 272.139 225.167 273.36C241.386 286.862 261.914 295.342 284.377 296.42C286.191 296.507 287.715 297.817 287.948 299.586C288.518 303.907 288.812 308.317 288.812 312.795C288.812 355.708 261.783 392.292 223.861 406.369C223.068 406.664 222.192 406.664 221.398 406.369C183.475 392.293 156.445 355.708 156.444 312.794C156.444 308.316 156.738 303.907 157.309 299.586C157.542 297.817 159.066 296.507 160.88 296.42C183.343 295.342 203.871 286.862 220.09 273.36Z",
    fill: "#F8EEE9",
    stroke: "#B54509",
    strokeWidth: 0.888383
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4556_19496"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 215.754,
    width: 480,
    height: 348.493,
    rx: 16.4384,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustrationKyc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illustration-kyc.927f5fddfd6814b77c3dade4654938de.svg";